import React from 'react'

import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import Map from '../../mencontact/Map'


function ContactUS() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Contact US" />
            
                
            <section id="services" className="services-area pt-120 pb-90 fix">
                {/*   */}
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Contact Info
                                </h5>
                                <h2>Get In Touch</h2>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="services-box text-center">
                                <div className="services-icon">
                                    <img src="assets/img/bg/contact-icon01.png" alt="image" />
                                </div>
                                <div className="services-content2 text-left  c-lineheight2dot5 text-dark fs-5 text">

                                    <p><i className="fal fa-phone-alt me-2"></i>Administration : 0877-250-3507</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>Establishment : 0877-250-3503</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>Academics : 0877-250-3530</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>Admissions : 0877-250-3532</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>Accounts : 0877-250-3545</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>Library : 0877-250-3591</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>Placement : 0877-250-3672</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>Recruitment : 0877-250-3505</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>Stores : 0877-250-3571</p>
                                    <p><i className="fal fa-phone-alt me-2"></i>Hostel & Mess Establishment (HoME) : 08772503156</p>
                                    <p className="mt-3"> Search Contacts </p>

                                    <p> <Link className="c-link" to="https://iittp.ac.in/TD" target="_blank">  Telephone Directory </Link> </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <div className="services-box text-center active">
                                <div className="services-icon">
                                    <i className="fas fa-alarm-clock"></i>
                                </div>
                                <div className="services-content2 fs-6  text-dark c-lineheight2dot5">

                                    <b>Working Days and Timings</b>
                                    <p>    Institute working days: Monday to Friday</p>
                                    <p>Institute working hours:09:00am to 05:30pm </p>

                                </div>
                            </div>

                            <div className="services-box text-center mt-5">
                                <div className="services-icon">
                                    <img src="assets/img/bg/contact-icon03.png" alt="image" />
                                </div>
                                <div className="services-content2">
                                    
                                    <p className='fs-4 fw-bold mb-3'> Address</p>
                                    <h6 className='lh-lg fs-5 '>
                                    <p>  Indian Institute of Technology Tirupati</p>
                                    <p>Yerpedu – Venkatagiri Road, Yerpedu Post,</p>
                                    <p>Tirupati District,</p>
                                    <p>Andhra Pradesh - 517619.</p>
                                    </h6>
                          
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='mt-5 mb-3'>
                        <h4 className='mt-5 mb-3'> Map</h4>
                        <Map value="500" />
                    </div>
                </div>

    
            </section>
        </>
    )
}

export default ContactUS